import VueQRCodeComponent from 'vue-qrcode-component'

export default async ({ Vue }) => {
  Vue.component('qr-code', VueQRCodeComponent)
}
